import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { PriceService } from '@app/_services/masters/price.service';
import { price } from '@app/_models/price';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-price-master-add',
  templateUrl: './price-master-add.component.html',
  styleUrls: ['./price-master-add.component.css']
})
export class PriceMasterAddComponent implements OnInit {
  RequestTypeDropDown = [];
  price = new price();
  yearrangeStart = [];
  yearrangeEnd = [];

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private priceService: PriceService,
    private modalService: NgbModal, config: NgbModalConfig, private router: Router, private verifyDocService: VerifyDocumentService) {

    Array(101).fill(0).map((x, i) => {
      this.yearrangeStart.push({ id: i, year: i })
    });

    Array(100).fill(1).map((x, i) => {
      this.yearrangeEnd.push({ id: `${i + 1}`, year: i + 1 })
    });

  }
  priceForm: FormGroup;
  submitted = false;
  showModalBox: boolean = false;
  getresponse: any;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  returnUrl;
  selectedStartYear: number;
  selectedEndYear: number;
  selectedServiceName: string;
  yearGreaterthan;
  yearSmallerthan;
  DocumentTypeDropDown:[];
  selecteddocumentType: string;
  // yearrangeStart = [{ id: 1, year: "1" },
  // { id: 2, year: "2" },
  // { id: 3, year: "3" }];
  // yearrangeEnd = [{ id: 1, year: "1" },
  // { id: 2, year: "2" },
  // { id: 3, year: "3" }];

  ngOnInit(): void {
    this.priceForm = this.formBuilder.group({
      requestTypeId: ['', Validators.required],
      yearrangeStart: ['', Validators.required],
      yearrangeEnd: ['', Validators.required],
      amount: ['', Validators.required],
      securitycharge: ['', Validators.required],
      gst: ['', Validators.required],
      doctypeId: ['', Validators.required]
    });

    this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

      this.verifyDocService.getDocuments()
      .pipe(first())
      .subscribe(
        data => {
          this.DocumentTypeDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )

  }
  get f() { return this.priceForm.controls; }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  addPrice() {
    this.submitted = true;

    if (this.priceForm.invalid) {
      return;
    }
    this.price.yearrangeStart = this.selectedStartYear;
    this.price.serviceName = this.selectedServiceName;
    this.price.yearrangeEnd = this.selectedEndYear;
    this.priceService.addPrice(this.price)


      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }

      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('10');
  }
  goBack() {
    this.eventService.emit<string>('10');
  }

  onOptionsSelected() {

    var startval = Number(this.selectedStartYear);
    var toval = Number(this.selectedEndYear);

    if (startval >= toval) {
      this.yearGreaterthan = true;
      //alert('yeart to is gerater than year start');
    }
    else {
      this.yearGreaterthan = false;
    }

  }

  onOptionsSelectedStart()
  {
    var startval = Number(this.selectedStartYear);
    var toval = Number(this.selectedEndYear);

    if (startval >= toval) {
      this.yearSmallerthan = true;
      //alert('yeart to is gerater than year start');
    }
    else {
      this.yearSmallerthan = false;
    }
  }

}
